export default function LocationServiceProvider() {
  this.$get = ($t) => {
    'ngInject';

    function LocationService() {

      const self = this;

      self.serializeAddress = (address) => {
        if (!address) {
          return undefined;
        }

        let result = "";
        result += (address.address ? address.address : "") + ";";
        result += (address.zip ? address.zip : "") + ";";
        result += (address.city ? address.city : "") + ";";
        result += (address.state ? address.state : "") + ";";
        result += (address.country ? address.country : "") + ";";
        result += address.longitude + ";";
        result += address.latitude + ";";
        result += (address.bounds ? address.bounds.south : "") + ";";
        result += (address.bounds ? address.bounds.west : "") + ";";
        result += (address.bounds ? address.bounds.north : "") + ";";
        result += (address.bounds ? address.bounds.east : "");

        return result;
      }

      self.deserializeAddress = (string) => {
        if (!string) {
          return undefined;
        }

        let parts = string.split(';'), result = {};

        if (parts.length !== 11) {
          return undefined;
        }

        result.address = parts[0];
        result.zip = parts[1];
        result.city = parts[2];
        result.state = parts[3];
        result.country = parts[4];
        result.longitude = parts[5];
        result.latitude = parts[6];

        if (parts[7] && parts[8] && parts[9] && parts[10]) {
          result.bounds = {};
          result.bounds.south = parts[7];
          result.bounds.west = parts[8];
          result.bounds.north = parts[9];
          result.bounds.east = parts[10];
        }

        return result;
      }

      self.validateAddress = address => {
        if (!address) {
          return $t('shared.locations.invalid_address_error_message');
        }

        if (!address.building) {
          return $t('shared.locations.cant_recognize_address_error_message');
        }

        if (!address.country) {
          return $t('shared.locations.country_required_error_message');
        }

        // TODO change countries list
        let supportedCountries = ['united states', 'united kingdom', 'australia', 'canada'];
        if (supportedCountries.indexOf(address.country.toLowerCase()) < 0) {
          return $t('shared.locations.not_supported_country_error_message');
        }

        return null;
      };

      self.validateProfileAddress = address => {
        if (!address) {
          return $t('shared.locations.invalid_address_error_message');
        }

        if (!address.building) {
          return $t('shared.locations.cant_recognize_address_error_message');
        }

        return null;
      };

      self.validateWorkAreaAddress = address => {
        if (!address) {
          return $t('shared.locations.invalid_address_error_message');
        } else if (!address.country) {
          return $t('shared.locations.country_required_error_message');
        }

        return null;
      };

      self.serializeBounds = bounds => {
        const results = [];
        results.push(bounds.south);
        results.push(bounds.west);
        results.push(bounds.north);
        results.push(bounds.east);

        return results.join(';');
      };

    }

    return new LocationService();
  };
}